import React from "react"
import "./page.scss"
import Footer from "./footer"

const Page = ({ children, context }) => {
  return (
    <>
      <main>{children}</main>
      <Footer />
    </>
  )
}

export default Page
